const env = ['tables.toasttab.com', 'booking.toasttab.com'].includes(
  window.location.hostname
)
  ? 'prod'
  : 'staging'

export const GOOGLE_RECAPTCHA_KEY = (() => {
  switch (env) {
    case 'prod':
      return '6LcufigrAAAAAJCl1TRG1BogGNie3yarYPqDZzpa'
    case 'staging':
    default:
      return '6LdcYCgrAAAAAHHllG1Ct9jnzt-AS4uz1YrVjQ_a'
  }
})()
